// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__-ZEFo","background":"Panel_background__8xCIl","body":"Panel_body__qJ5SP"};